import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function InsightsIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" fill="none" viewBox="0 0 24 24" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        d="M8 21.5H4.83a2.33 2.33 0 0 1-2.33-2.33V16M8 2.5H4.83A2.33 2.33 0 0 0 2.5 4.83V8M16 21.5h3.17a2.33 2.33 0 0 0 2.33-2.33V16M16 2.5h3.17a2.33 2.33 0 0 1 2.33 2.33V8"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.391 12S6.521 6.235 12 6.235c5.478 0 8.609 5.765 8.609 5.765s-3.13 5.765-8.609 5.765C6.522 17.765 3.391 12 3.391 12Z"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 14.162c1.297 0 2.348-.968 2.348-2.162S13.297 9.838 12 9.838 9.652 10.806 9.652 12s1.051 2.162 2.348 2.162Z"
      />
    </Icon>
  );
}
